<template>
    <a :style="{
        'text-decoration': underline ? 'underline' : 'auto',
        'cursor': disabled ? 'not-allowed' : 'pointer'
        }" 
        :href="disabled || !href ? undefined : href"
        :target="target ? '_blank' : '_self'">
        
        <i :class="icon"></i> 
        {{modelValue}}
    </a>
</template>

<script>
export default {
    name: 'tw-link',
    props: {
        modelValue: {
            type: String,
            default: '超链接'
        },
        underline: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        href: String,
        icon: String,
        target: {
            type: Boolean,
            default: false
        }
    }
}
</script>